module.exports = __webpack_public_path__ + "HANMUChome-2.e36f431f.png";